export default "__VITE_ASSET__79551ac2__"